
define('text!templates/modules/calendar/animated-session/exercise/weight/weight-content.html',[],function () { return '<table class="exercise-weight-table table table-bordered" ></table>\n<div class="menu-actions btn-group btn-group-justified"></div>\n';});

